import { cloudApiBase, isCloudConfigured } from "@/integrations/cloud/cloudConfig";

const parseErrorMessage = async (response: Response): Promise<string> => {
  const fallback = `Request failed with status ${response.status}.`;

  try {
    const payload = (await response.json()) as { error?: unknown; message?: unknown };
    if (typeof payload.error === "string" && payload.error.trim().length > 0) {
      return payload.error;
    }
    if (typeof payload.message === "string" && payload.message.trim().length > 0) {
      return payload.message;
    }
  } catch {
    // no-op
  }

  const text = await response.text().catch(() => "");
  return text.trim().length > 0 ? text : fallback;
};

export const requestCloudApi = async <T>(
  path: string,
  init: RequestInit = {}
): Promise<T> => {
  if (!isCloudConfigured) {
    throw new Error(
      "Cloud backend is not configured. Set VITE_CLOUD_API_URL."
    );
  }

  const target = `${cloudApiBase}${path.startsWith("/") ? path : `/${path}`}`;
  const response = await fetch(target, init);
  if (!response.ok) {
    throw new Error(await parseErrorMessage(response));
  }

  if (response.status === 204) {
    return undefined as T;
  }

  return (await response.json()) as T;
};
